export default __webpack_public_path__ + "static/media/avatar_nikki_dog7.2f20aba0.mp3";